import ExchangeRateCard from "@/components/ExchangeRateCard/ExchangeRateCard.vue";

export default {
  name: "ProjectedOutcomes",

  components: {
    ExchangeRateCard
  },

  props: {
    outcomes: {
      type: Object,
      required: true,
      default: () => ({
        assets: 0,
        jobs_expected: 0,
        jobs_verified: 0,
        revenue: "R0",
        recycled: "R0",
        bonus: "R0",
        survival_rate: "0%",
        cost_per_job: "R0",
        break_even_period: "0mo"
      })
    }
  },

  data() {
    return ({
      ui_labels: ({
        card_title: "Projected Outcomes",
        assets: "Assets",
        jobs_expected: "Jobs Expected",
        jobs_verified: "Jobs Verified",
        revenue: "Revenue",
        recycled: "Recycled",
        bonus: "Bonus",
        survival: "Survival",
        cost_job: "Cost/Job",
        break_even: "Break-Even",
        chart_title: "Observed vs Modeled",
        exchange_rate_title: "EXCHANGE RATE",
        exchange_rate_subtext: "per verified job"
      }),
      ui_config: ({
        header_icon_class: "bi bi-stars",
        assets_icon: "bi bi-buildings",
        jobs_expected_icon: "bi bi-people",
        jobs_verified_icon: "bi bi-check-square",
        revenue_icon: "bi bi-graph-up-arrow",
        recycled_icon: "bi bi-recycle",
        bonus_icon: "bi bi-lightning-charge"
      })
    });
  }
};